import Vue from "vue";
import { Component } from "vue-property-decorator";
import locale from "element-ui/lib/locale";
import { namespace, Action } from "vuex-class";
import UserTypes from "../../../../store/user/user-types.store";
import {
    LOCALSTORAGE_LANG,
    APICONFIG_LANGUAGE_ID,
    TIME_TO_RELOAD_CHANGE_LOCALE
} from "../../../../common/constants";
import { storeModules } from "../../../../store";
import { LanguageHelper } from "../../../../utils/language-helper";
import moment from "moment";
import LanguageSelectComponent from "../../../../components/language-select/LanguageSelectComponent.vue";
import EventTracker from "../../../../utils/event-tracker";
import { TRACKING_EVENTS } from "../../../../common/tracking-event.constants";
const UserAction = namespace(storeModules.User, Action);
@Component({
    template: require("./template.html"),
    components: {
        "language-select": LanguageSelectComponent
    }
})
class NavbarComponent extends Vue {
    @UserAction(UserTypes.Set.USER_CONFIG)
    storeSetUserConfig: (data: any) => Promise<any>;

    currentLanguageCode: string = "en-US";

    mounted() {
        this.currentLanguageCode = this.$i18n.locale;
    }

    handleLocaleChanged(code: string) {
        if (code !== this.$i18n.locale) {
            this.storeSetUserConfig([
                {
                    KeyName: APICONFIG_LANGUAGE_ID,
                    KeyValue: LanguageHelper.convertLanguageInt(code)
                }
            ]).then(() => {
                // UPDATE LOCALE FOR I18N
                localStorage.setItem(LOCALSTORAGE_LANG, code);
                this.$i18n.locale = code;

                // UPDATE LOCALE FOR MOMENT
                moment.locale(code);
                locale.use(code);

                // UPDATE LOCALE FOR OMNICASA MAP
                const options = localStorage.getItem("options") as any;
                if (options != null) {
                    const optionObject = JSON.parse(options);
                    optionObject.languageId = LanguageHelper.convertLanguageInt(
                        code
                    );
                    localStorage.setItem(
                        "options",
                        JSON.stringify(optionObject)
                    );
                }

                // this.$notify({
                //   title: this.$t('INFO').toString(),
                //   dangerouslyUseHTMLString: true,
                //   message: `<div class="notification-message-custom">${this.$t('NOTI_RELOAD_LOCALE', {time : TIME_TO_RELOAD_CHANGE_LOCALE/1000})}</div>`,
                //   type: 'success',
                //   duration: TIME_TO_RELOAD_CHANGE_LOCALE,
                //   customClass: "success"
                // })

                setTimeout(() => {
                    window.location.reload();
                }, TIME_TO_RELOAD_CHANGE_LOCALE);
            });
        }
        EventTracker.logEvent({
            FormName: TRACKING_EVENTS.PAGES.GLOBAL,
            Action: TRACKING_EVENTS.EVENTS.CHANGE_LANGUAGE,
            FormId: 0,
            Comment: {
                name: "newProperty"
            }
        });
    }
}

export default NavbarComponent;
